export enum StorageType {
  FOLDED = 'FOLDED',
  HANGER = 'HANGER',
  FOLDED_OVERSIZE = 'FOLDED_OVERSIZE',
  HANGER_OVERSIZE = 'HANGER_OVERSIZE',
  FOLDED_AFTER = 'FOLDED_AFTER',
}
